import type { StoredUsers } from '~/gql/users/users'
import { useState } from 'react'

export type UserDialog = 'form' | 'import' | 'delete' | 'impersonate' | 'sessions'

/**
 * La modale ouverte depuis la liste des comptes, et le compte qu'elle vise.
 * Fermer garde le compte : les modales de suppression, d'impersonation et de
 * sessions restent montées le temps de leur animation de sortie.
 */
export function useUserDialogs() {
  const [open, setOpen] = useState<UserDialog | null>(null)
  const [user, setUser] = useState<StoredUsers | undefined>()

  const show = (dialog: UserDialog, target?: StoredUsers) => {
    setUser(target)
    setOpen(dialog)
  }

  const close = () => setOpen(null)

  return { open, user, show, close }
}

export type UserDialogs = ReturnType<typeof useUserDialogs>
